import { handleDeleteRequest, handleGetRequest, handlePostRequest } from ".";
import { URI } from "../../constants/URI";
import {
  appendSubFiles,
  setEncKey,
  setFileType,
  setFiles,
  setPaginationData,
  setSubFiles,
  setTotalVolume,
  setTotalVolumeInBytes,
} from "../slices/fileSlice";
import { store } from "../store";

export const getFileCount = async () => {
  const res = await handleGetRequest(URI.file_type);
  if (res?.response) store.dispatch(setFileType(res.response.data));
};

export const getTotalVolume = async () => {
  const res = await handleGetRequest(URI.total_volume, null, {
    loading: false,
  });
  if (res?.response)
    store.dispatch(setTotalVolume(res.response.totalUsedVolume));
  store.dispatch(setTotalVolumeInBytes(res.response.totalUsedBytes));
};

export const getDirectory = async (type) => {
  const res = await handleGetRequest(URI.get_directory, null, {
    toast: false,
    params: {
      type,
    },
  });
  if (res.response) store.dispatch(setFiles(res.response));
};

export const getFiles = async (type, directory, page = 1, append = false) => {
  const res = await handleGetRequest(URI.get_files, null, {
    toast: false,
    params: {
      type,
      directory,
      page,
      limit: 10, // You can make this configurable
    },
  });

  if (res.response) {
    // Store pagination data
    store.dispatch(setPaginationData(res.response.paginationData));

    if (append && page > 1) {
      // Append new files to existing ones (for pagination)
      store.dispatch(appendSubFiles(res.response.files));
    } else {
      // Replace all files (for initial load or refresh)
      store.dispatch(setSubFiles(res.response.files));
    }
  }

  return res;
};

// New function specifically for loading more files
export const loadMoreFiles = async (type, directory, page) => {
  return await getFiles(type, directory, page, true);
};

export const getEncFileKeys = async () => {
  const res = await handleGetRequest(URI.encryption_keys_file, null, {
    toast: false,
    loading: false,
  });
  if (res) store.dispatch(setEncKey(res?.keys));
};

export const deleteFile = async (body) => {
  const res = await handleDeleteRequest(URI.delete_files, body);
  return res;
};

export const uploadFile = async ({
  file,
  type = "images",
  ext = "jpg",
  mimeType = "image/jpg",
  fileName,
  keyCreationDate,
  directory = "camera",
}) => {
  try {
    const formData = new FormData();
    formData.append("files", file);
    formData.append("type", type);
    formData.append("ext", ext);
    formData.append("mimeType", mimeType);
    formData.append("fileName", fileName);
    formData.append("keyCreationDate", keyCreationDate);
    formData.append("directory", directory);

    const response = await handlePostRequest(formData, {
      toast: false,
    });
    console.log("🚀 ~ response:", response);

    return response;
  } catch (error) {
    console.log("🚀 ~ error:", error);
    return null;
  }
};
